<template>
  <div>
    <fm-generate-form
      :data="jsonData"
      @on-change="onChange"
      :value="formData"
      ref="generateForm"
    >
    </fm-generate-form>
      <el-button type="primary" @click="handleSubmit">提交</el-button>
  </div>
</template>
<script src="https://unpkg.com/form-making/public/lib/ace/ace.js"></script>
<script>
// 需要在设计器中预览代码需要引入ace.js库 (index.html中引入ace.js，可以预览生成的json或html，如果不引也可以生成，但没有解析格式样式。)-->
//  如何是不联网的话，可以参考下  https://www.jianshu.com/p/bb5109901132
export default {
  props:['jsonData'],
  data() {
    return {
      formData: {
        // show: "",
      },
    };
  },
  components: {},
  methods: {
    onChange(field, value,data) {
      console.log(field)
        console.log(value)
        console.log(data)
        // console.log(this.formData)
      if (field == "name") {
        // this.formData.show = value;
        
      }
    },
       handleSubmit () {
          this.$refs.generateForm.getData().then(data => {
           console.log(data)
          //  console.log(JSON.stringify(data))

          }).catch(e => {})
      }
  },
  created() {
    console.log(this.jsonData)
  },
};
</script>
